<p>base-widget works!</p>
